module.exports = __webpack_public_path__ + "static/media/down-arrow.70986988.svg";